import React, { useEffect } from "react";

export default function Toast({ message, type = "success", onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const borderColors = {
    success: "border-green-400",
    error: "border-red-400",
    warning: "border-yellow-400",
    info: "border-blue-400",
  };

  return (
    <div
      className="
        fixed top-5 left-1/2 -translate-x-1/2
        z-50 pointer-events-none
      "
    >
      <div
        className={`
          pointer-events-auto
          px-6 py-3 rounded-xl text-white text-center
          bg-neutral-900 border shadow-2xl
          animate-[fadeIn_0.25s_ease-out,fadeOut_0.25s_ease-in_2.75s_forwards]
          ${borderColors[type] || borderColors.success}
        `}
      >
        {message}
      </div>
    </div>
  );
}
